

















import { Component, Prop, Vue } from "vue-property-decorator";
import { EventBus } from "@/event-bus";
import ApplicationMessageModel from "@/models/security/zorgID/ApplicationMessageModel";

@Component
export default class ApplicationMessageComponent extends Vue {
  public Messages: Array<ApplicationMessageModel> = new Array<
    ApplicationMessageModel
  >();

  public created() {
    var me = this;
    var defaultShowTimeMs: number = 5000;

    EventBus.$on(
      "application_message_component_success",
      (x: string, showTimeMs: number = defaultShowTimeMs) => {
        me.setMessage(x, "success", showTimeMs);
      },
    );

    EventBus.$on(
      "application_message_component_info",
      (x: string, showTimeMs: number = defaultShowTimeMs) => {
        me.setMessage(x, "info", showTimeMs);
      },
    );

    EventBus.$on(
      "application_message_component_warning",
      (x: string, showTimeMs: number = defaultShowTimeMs) => {
        me.setMessage(x, "warning", showTimeMs);
      },
    );

    EventBus.$on(
      "application_message_component_error",
      (x: string, showTimeMs: number = defaultShowTimeMs) => {
        me.setMessage(x, "error", showTimeMs);
      },
    );
  }

  private setMessage(
    message: string,
    messageType: string,
    showTimeMs: number = 5000,
  ) {
    var me = this;
    var msg = new ApplicationMessageModel();
    msg.key = new Date().getTime();
    msg.Show = true;
    msg.MessageType = messageType;
    msg.Message = message;
    me.Messages.push(msg);
    setTimeout(() => {
      me.Messages.splice(me.Messages.indexOf(msg), 1);
    }, showTimeMs);
  }
}
